<template>
  <CreatorSignupBody/>
</template>

<script>
// @ is an alias to /src
import CreatorSignupBody from '@/components/CreatorSignupBody.vue'

export default {
  name: 'CreatorSignupView',
  components: {
    CreatorSignupBody
  }
}
</script>
